// extracted by mini-css-extract-plugin
export default {"tabs":"distributionOfScore_tabs__2jG9G","table":"distributionOfScore_table__exPRO"};